import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import PolicyPage from './PolicyPage';
import HowItWorksPage from './pages/HowItWorksPage';
import PricingPage from './pages/PricingPage';
import FaqPage from './pages/FaqPage';

const POLICIES = {
  privacy: { uuid: 'c96fe9bd-5fc1-45bf-ac2f-2c384fd2b2fa', title: 'Privacy Policy' },
  cookies: { uuid: '8aea6edf-9124-4a2a-a0ee-8dba9f883f21', title: 'Cookie Policy' },
  terms:   { uuid: 'ebeb932c-f22b-4110-845c-1dd9ac60a168', title: 'Terms & Conditions' },
} as const;

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/privacy-policy" element={<PolicyPage policyUUID={POLICIES.privacy.uuid} title={POLICIES.privacy.title} />} />
          <Route path="/cookie-policy" element={<PolicyPage policyUUID={POLICIES.cookies.uuid} title={POLICIES.cookies.title} />} />
          <Route path="/terms" element={<PolicyPage policyUUID={POLICIES.terms.uuid} title={POLICIES.terms.title} />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
